
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class ChooseUsers extends Vue {
    @Getter pmEmployeeList: any;
    @Getter setAccessUser: any;
    @Prop() chooseEmployeeVisible: boolean;
    @Prop() currentAccessInfo: any;
    @Prop() confirmSelectedEmployee: Function;
    @Action('getPMEmpliyeeList') getPMEmpliyeeList: Function;
    @Action('setAccessUsers') setAccessUsers: Function;

    searchVal: string = '';
    multipleSelection: any = []; // 选中的列
    leftTable: any = [];
    rightTable: any = [];

    toRight() {
       // 右边数组去重
        for (const item of this.multipleSelection) {
            if (!this.rightTable.find((it: any) => it.PmUserCode === item.PmUserCode)) {
                this.rightTable.push(item);
            }
        }
        this.leftTable = this.leftTable.filter((item: any) => {
           return !this.rightTable.find((it: any) => it.PmUserCode === item.PmUserCode);
        });
    }

    handleRemove(val: any) {
        this.rightTable = this.rightTable.filter((item: any) => item.PmUserCode !== val.PmUserCode);
    }

    // 搜索用户
    onSearch() {
        this.getPMEmpliyeeList({keyword: this.searchVal, isPage: false, top: 100});
    }

    @Watch('pmEmployeeList.loading')
    watchEmployeeList(newVal: boolean, oldVal: boolean) {
        if (oldVal === true && newVal === false) {
            this.leftTable = this.pmEmployeeList.data || [];
        }
    }

    @Watch('chooseEmployeeVisible')
    watchOpenDialog(newVal: boolean, oldVal: boolean) {
        if (oldVal === false && newVal === true) {
            this.rightTable = this.currentAccessInfo.UserInfos || [];
        }
    }

    @Watch('setAccessUser.loading')
    watchCommit(newVal: boolean, oldVal: boolean) {
        if (oldVal === true && newVal === false) {
            this.clearDialog();
            this.$emit('closeChooseEmployeeVisible', true);
        }
    }

    // 多线弹窗
    handleSelectionChange(val: any) {
        this.multipleSelection = val;
    }

    // 关闭弹窗
    handleClose() {
        this.clearDialog();
        this.$emit('closeChooseEmployeeVisible', false);
    }

    // 清空表格数据
    clearDialog() {
        this.searchVal = '';
        this.multipleSelection = [];
        this.leftTable = [];
        this.rightTable = [];
    }

    // 确认选择的条目
    confirmbtn() {
        if(this.confirmSelectedEmployee){
            this.confirmSelectedEmployee(this.rightTable);
        }else{
            this.setAccessUsers({ReportID: this.currentAccessInfo.ReportID, Name: this.currentAccessInfo.Name, UserInfos: this.rightTable});
        }
    }

    // 确认搜索
    onSubmit() {
        this.getPMEmpliyeeList({keyword: this.searchVal, isPage: false, top: 100});
    }

}
